import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import React, { useState, useEffect } from 'react';

import './styles/transition.css';

// Pages
import UploadDataPage from './components/pages/UploadDataPage';
import InvitationsPage from './components/pages/InvitationsPage';
import Homepage from './components/pages/Homepage';

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <TransitionGroup>
      <CSSTransition key={location.key} classNames="route" timeout={300}>
        <Routes location={location}>
          <Route path="/person/:personId" element={<InvitationsPage />} />
          <Route path="/sync" element={<UploadDataPage />} />
          <Route path="/" element={<Homepage />} />
          <Route path="*" element={<h1>Not Found</h1>} />
        </Routes>
      </CSSTransition>
    </TransitionGroup>
  );
}

function App() {
  return (
    <Router>
      <AnimatedRoutes />
    </Router>
  );
}

export default App;
